export interface EditRequestReasonTooltipContent {
  declineReason?: string;
  pauseReason?: string;
}

export function getEditRequestReasonTooltipContent (
  pauseReason?: string | null,
  declineReason?: string | null,
): EditRequestReasonTooltipContent | null {
  const content: EditRequestReasonTooltipContent = {};

  const trimmedDeclineReason = declineReason?.trim();
  if (trimmedDeclineReason) {
    content.declineReason = trimmedDeclineReason;
  }

  const trimmedPauseReason = pauseReason?.trim();
  if (trimmedPauseReason) {
    content.pauseReason = trimmedPauseReason;
  }

  if (!content.declineReason && !content.pauseReason) {
    return null;
  }

  return content;
}
